import { Button } from "@mui/material";
import FormTextField from "components/FormFields/FormTextField";
import LoadingSpinner from "components/LoadingSpinner";
import React, { useEffect, useState } from "react";
import { formatIsoDate } from "utils/date";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";

const BatteryInformationModal = ({
  isModalOpen,
  onClose,
  isLoading,
  onDownload,
  batteryInformation,
}) => {
  const { report_date } = batteryInformation;
  const [isUserEntry, setIsUserEntry] = useState(false);
  const [batteryStatus, setBatteryStatus] = useState();
  const [submitClicked, setSubmitClicked] = useState(false);

  useEffect(() => {
    if (batteryInformation) {
      getBatteryStatus();
    }
  }, [batteryInformation]);

  const getBatteryStatus = () => {
    const { battery_longevity, battery_percentage, battery_voltage } =
      batteryInformation;

    let value;
    if (battery_longevity) {
      const batteryLongevitySuffix = !isNaN(battery_longevity)
        ? battery_longevity > 1
          ? "years"
          : "year"
        : "";
      value = `${battery_longevity} ${batteryLongevitySuffix}`;
    } else if (battery_percentage) {
      value = `${battery_percentage}%`;
    } else if (battery_voltage) {
      value = `${battery_voltage}V`;
    }

    setBatteryStatus(value);
  };

  const handleGenerate = () => {
    setSubmitClicked(true);
    if (!batteryStatus) {
      return;
    }
    onDownload(batteryStatus);
  };

  return (
    <ModalWrapper
      title="Battery Longevity"
      show={isModalOpen}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
    >
      <div>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div className="mt-2 generate-template-modal__content">
              <p>
                {batteryStatus && report_date && !isUserEntry ? (
                  <span>
                    This patient's implanted device has the following battery
                    status reported on <b>{formatIsoDate(report_date)}</b>.
                    Please update the battery status if required.
                  </span>
                ) : (
                  <span>
                    Update the battery life before downloading the template.
                  </span>
                )}
              </p>
            </div>
            <div>
              <FormTextField
                fullWidth
                required
                label="Battery Life"
                value={batteryStatus}
                hasError={submitClicked && !batteryStatus}
                errorMessage={!batteryStatus && "Battery status is required."}
                onChange={(e) => {
                  const value = e.target.value;
                  setIsUserEntry(true);
                  setBatteryStatus(value);
                }}
              />
            </div>
            <div className="mt-2 generate-template-modal__footer">
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => onClose()}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#94ba33",
                  color: "white",
                }}
                onClick={handleGenerate}
              >
                Generate
              </Button>
            </div>
          </>
        )}
      </div>
    </ModalWrapper>
  );
};

export default BatteryInformationModal;
